var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid rounded mx-auto d-block",attrs:{"id":"icon","src":"assets/icon-450.png","alt":"The knockturnmc icon"}})}
var staticRenderFns = []

export { render, staticRenderFns }